import React from "react";
import GenericComponent from "../../dataforms/GenericComponent";
export const ContentNotFoundReportView = () => {
    return (
        <div className="view">
            <GenericComponent
                enableNew={false}
                enableEdit={false}
                dataObject="contentNotFoundErrorData"
                enableClone={false}
            />
        </div>
    );
};
